import React, { createContext, useState, useContext } from "react";
import { api } from "../services/api";

const AuthContext = createContext();

function carregarSessaoInicial() {
  try {
    const sessao = JSON.parse(localStorage.getItem("auth") || "null");

    if (sessao?.token && sessao?.usuario) {
      api.defaults.headers.common.Authorization = `Bearer ${sessao.token}`;
      return sessao;
    }
  } catch (error) {
    localStorage.removeItem("auth");
  }

  return { token: null, usuario: null };
}

export function AuthProvider({ children }) {
  const sessaoInicial = carregarSessaoInicial();
  const [token, setToken] = useState(sessaoInicial.token);
  const [usuario, setUsuario] = useState(sessaoInicial.usuario);
  const isLoggedIn = Boolean(token && usuario);

  const login = async (loginUsuario, senha) => {
    try {
      const response = await api.post("/login", {
        login: loginUsuario,
        password: senha,
      });

      const novaSessao = {
        token: response.data.token,
        usuario: response.data.user,
      };

      api.defaults.headers.common.Authorization = `Bearer ${novaSessao.token}`;
      localStorage.setItem("auth", JSON.stringify(novaSessao));
      setToken(novaSessao.token);
      setUsuario(novaSessao.usuario);

      return { sucesso: true, mensagem: "Login realizado com sucesso!" };
    } catch (error) {
      return {
        sucesso: false,
        mensagem: error.response?.data?.message || "Usuario ou senha incorretos!",
      };
    }
  };

  const logout = async () => {
    try {
      if (token) {
        await api.post("/logout");
      }
    } catch (error) {
      console.error("Erro ao sair:", error);
    } finally {
      setToken(null);
      setUsuario(null);
      delete api.defaults.headers.common.Authorization;
      localStorage.removeItem("auth");
    }
  };

  return (
    <AuthContext.Provider value={{ isLoggedIn, usuario, token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}